<div class="card-content">

      <div>
        <h3 style="color: #9b7544">Emergency Contact (If Any)</h3>
      </div>
                     <div class="row"  style="margin-top:30px">  
                        <div class="col-12 text-center" >
                            
                              <label style="color: #9b7544">Alternate Contact:</label>
                              <input type="number" [(ngModel)]="alternatecontact">
                          </div>
                     </div>
                     <div class="row">
                     <div class="col-12 text-left" style="margin-top: 10px; margin-left: 10px;">
                       
                         <label style="color: #9b7544">Vet Name:</label>
                         <input type="text" [(ngModel)]="vetname">
                     </div>
                     </div>
                     <div class="row">
                     <div class="col-12 text-left" style="margin-top: 10px; margin-left: 10px;">
                        
                          <label style="color: #9b7544">Vet Contact:</label>
                          <input type="number" [(ngModel)]="vetcontact">
                      </div>
                     </div>
                     <div  class="row" style="margin-top:40px"> 
                        <div class="col-6 text-center" >
                          <button  class="btn btn-outline-success btn-block" (click)="done()"> Ok </button>
                        </div>
                        <div class="col-6 text-center" >
                          <button class="btn btn-outline-success btn-block" (click)="cancel()"> Cancel </button>
                          </div>
                     </div>
           
                 </div>